import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ReportGroup, ReportMetrics } from 'models';
import { toLocalISOString } from 'utils/date';

@Injectable({
    providedIn: 'root'
})
export class ReportService {
    constructor(private http: HttpClient) {}

    public getMetrics(from: Date, to: Date): Observable<ReportMetrics> {
        return this.http.get<ReportMetrics>(`api/reports/metrics`, {
            params: new HttpParams({
                fromObject: {
                    from: from ? toLocalISOString(from) : null,
                    to: to ? toLocalISOString(to) : null
                }
            })
        });
    }

    public get(): Observable<ReportGroup[]> {
        return this.http.get<ReportGroup[]>('api/reports/get');
    }

    public run(reportId: number, from: Date, to: Date): Observable<any> {
        return this.http.get(`api/reports/run`, {
            params: new HttpParams({
                fromObject: {
                    reportid: reportId.toString(),
                    from: from.toString(),
                    to:  to.toString()
                }
            })
        });
    }
}
